module.exports = __webpack_public_path__ + "img/s13.eadf9bc.png";